import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useHistory, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { useData } from "../../contexts/DataContext";
import { getPlayerStats } from "./../../tools/index";
import "./Player.css";
import PlayerInfo from "./playerComponents/PlayerInfo";
import PlayerStatistics from "./playerComponents/PlayerStatistics";
import PlayerTabs from "./playerComponents/PlayerTabs";
import PlayerWagering from "./playerComponents/PlayerWagering";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiTextField-root": {
      minWidth: 200,
      width: "100% !important",
    },
    "& .MuiFormGroup-row": {
      justifyContent: "center",
    },
    "& .MuiFormControl-root": {
      justifyContent: "center",
    },
    "& .MuiFormControlLabel-root": {
      margin: 0,
    },
  },
}));
const Player = withRouter(
  forwardRef((props) => {
    const [player, setPlayer] = useState(null);
    const [playerStats, setPlayerStats] = useState();
    const [loading, setLoading] = useState(true);


    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const [statsNeedsReload, setStatsNeedsReload] = useState(false);

    const setStatisticsToReload = () => {
      setStatsNeedsReload(prev => !prev);
    };


    const classes = useStyles();
    let history = useHistory();

    // ← Función que actualiza el estado del jugador (para insert) sin eliminar lo que ya funciona para el update
    const updatePlayerField = (field, value) => {
      setPlayer((prev) => ({
        ...(prev || {}),
        [field]: value,
      }));
    };

    const requestPlayerInfo = useCallback(async (id) => {
      if (!id) return;

      try {
        setLoading(true);

        getPlayerStats(id, setPlayerStats);

        const response = await axios.get(
          `${process.env.REACT_APP_API2_URL}/Player/Player_GetInfoByID?idPlayer=${id}`
        );

        setPlayer(typeof response.data === "object" ? response.data : null);

      } catch (err) {
        console.error("Error loading player:", err);
      } finally {
        setLoading(false);
      }
    }, []);

    useEffect(() => {
      const id = props.match.params.id;

      if (!id) return;

      if (id === "0") {
        setPlayer({
          IdPlayer: 0,
          Player: "",
          Password: "",
          Name: "",
          LastName: "",
          LastName2: "",
          CreditLimit: 0,
          TempCredit: 0,
          OnlineAccess: false
        });

        setLoading(false);
        return;
      }

      requestPlayerInfo(id);

    }, [props.match.params.id, requestPlayerInfo]);

    const changeUser = useCallback(async (userId) => {
      try {
        const id = userId ?? props.match.params.id;

        const { data } = await axios.get(
          `${process.env.REACT_APP_API2_URL}/Player/Player_GetInfoByID?idPlayer=${id}`
        );

        props.history.push(`/player/${data.idPlayer}`);
      } catch (err) {
        console.error("Error changing user:", err);
      }
    }, [props.history, props.match.params.id]);

    const InsertPlayer = async (row) => {
      let RequestDTO = {
        IdPlayer: row.idPlayer,
        IdLineType: row.idLineType,
        IdOffice: row.idOffice,
        IdAgent: row.idAgent,
        IdCurrency: row.idCurrency,
        IdGrouping: row.idGrouping,
        IdSource: 64,
        IdProfile: row.idProfile,
        IdPlayerRate: row.idPlayerRate,
        IdBook: row.idBook,
        IdTimeZone: row.idTimeZone,
        IdLanguage: row.idLanguage,
        Player1: row.player,
        Password: row.password,
        Name: row.name,
        LastName: row.lastName,
        LastName2: row.lastName2,
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        Country: "",
        Zip: "",
        Phone: "",
        Fax: "",
        Email: "",
        CreditLimit: row.creditLimit,
        TempCredit: row.tempCredit,
        OnlineAccess: row.onlineAccess,
        OnlinePassword: row.onlinePassword,
        OnlineMessage: row.onlineMessage,
        OnlineMaxWager: row.onlineMaxWager,
        OnlineMinWager: row.onlineMinWager,
        MaxWager: row.maxWager,
        MinWager: row.minWager,
        ChartPercent: row.chartPercent,
        Master: row.master,
        FlagMessage: row.flagMessage,
        IdFlagMessageType: row.idFlagMessageType,
        DuplicatedBets: row.duplicatedBets,
        DuplicatedBetsOnline: row.duplicatedBetsOnline,
        SettledFigure: row.settledFigure,
        ShowInTicker: row.showInTicker,
        EPOSPlayer: row.eposPlayer,
        EnableHorses: row.enableHorses,
        EnableCasino: row.enableCasino,
        EnableSports: row.enableSports,
        DateOfBirth: row.dateOfBirth,
        SecQuestion: row.secQuestion,
        SecAnswer: row.secAnswer,
        SignUpIP: "192.168.3.20",
        HoldBets: row.holdBets,
        HoldDelay: row.holdDelay,
        IdProfileLimits: row.idProfileLimits,
        EnableCards: row.enableCards,
        IdAffiliate: row.idAffiliate,
      };
      await axios({
        method: "post",
        url:
          process.env.REACT_APP_API2_URL +
          "/Player/Player_Insert?IdUser=" +
          userInfo.userId,
        data: RequestDTO,
      }).then((response) => {
        if (response.data > 0) {
          history.push(`/player/${response.data}`);
          window.location.reload();
        } else {
          history.push("/players");
        }
      });
    }
    const Updateplayer = async (row) => {
      let RequestDTO = {
        prmIdPlayer: row.idPlayer,
        prmIdLineType: row.idLineType,
        prmIdOffice: row.idOffice,
        prmIdAgent: row.idAgent,
        prmIdCurrency: row.idCurrency,
        prmIdGrouping: row.idGrouping,
        prmIdSource: row.idSource,
        prmIdProfile: row.idProfile,
        prmIdProfileLimits: row.idProfileLimits,
        prmIdPlayerRate: 1,
        prmIdBook: row.idBook,
        prmIdTimeZone: row.idTimeZone,
        prmIdLanguage: row.idLanguage,
        prmScheduleStyle: row.scheduleStyle,
        prmPlayer: row.player,
        prmPassword: row.password,
        prmName: row.name,
        prmLastName: row.lastName,
        prmLastName2: row.lastName2,
        prmAddress1: row.address1,
        prmAddress2: row.address2,
        prmCity: row.city,
        prmState: row.state,
        prmCountry: row.country,
        prmZip: row.zip,
        prmPhone: row.phone,
        prmFax: row.fax,
        prmEmail: row.email,
        prmStatus: row.status,
        prmAutoPay: row.autoPay,
        prmBalanceChecked: row.balanceChecked,
        prmCreditLimit: row.creditLimit,
        prmTempCredit: row.tempCredit,
        prmSoftLimitPercent: row.softLimitPercent,
        prmTempCreditExpire: row.tempCreditExpire,
        prmOnlineAccess: row.onlineAccess,
        prmOnlinePassword: row.onlinePassword,
        prmOnlineMessage: row.onlineMessage,
        prmOnlineMaxWager: row.onlineMaxWager,
        prmOnlineMinWager: row.onlineMinWager,
        prmMaxWager: row.maxWager,
        prmMinWager: row.minWager,
        prmChartPercent: row.chartPercent,
        prmMasterChart: row.masterChart,
        prmMaster: row.master,
        prmFlagMessage: row.flagMessage,
        prmIdFlagMessageType: row.idFlagMessageType,
        prmMaxActionPoints: row.maxActionPoints,
        prmBonusPointsStatus: row.bonusPointsStatus,
        prmBonusPointsExpire: row.bonusPointsExpire,
        prmBonusPointsStart: row.bonusPointsStart,
        prmLineStyle: row.lineStyle,
        prmNHLLine: row.nhlLine,
        prmMLBLine: row.mlbLine,
        prmPitcherDefault: row.pitcherDefault,
        prmDuplicatedBets: row.duplicatedBets,
        prmDuplicatedBetsOnline: row.duplicatedBetsOnline,
        prmScheduleFB: row.scheduleFB,
        prmScheduleBB: row.scheduleBB,
        prmScheduleHK: row.scheduleHK,
        prmScheduleBS: row.scheduleBS,
        prmSettledFigure: row.settledFigure,
        prmShowInTicker: row.showInTicker,
        prmEPOSPlayer: row.eposPlayer,
        prmEnableSports: row.enableSports,
        prmEnableCasino: row.enableCasino,
        prmEnableHorses: row.enableHorses,
        prmDateOfBirth: row.dateOfBirth,
        prmSecQuestion: row.secQuestion,
        prmSecAnswer: row.secAnswer,
        prmSignUpIP: "192.168.3.20",
        prmHoldBets: row.holdBets,
        prmHoldDelay: row.holdDelay,
        prmIdAffiliate: row.idAffiliate,
        prmIdUser: userInfo.userId,
        prmAllowNegTrans: row.allowNegTrans,
      };
      await axios({
        method: "post",
        url:
          process.env.REACT_APP_API2_URL +
          "/player/player_Update",
        data: RequestDTO,
      }).then((response) => {
        if (response.data === -1) {
          toast.error(`Error updating player ${player.Player}`);
        } else {
          toast.success(`${player.player} updated successfully`);
        }
        requestPlayerInfo(player?.IdPlayer || player?.idPlayer);
      });
    }

    const {
      data: { fullscreen },
    } = useData();

    if (loading) {
      return <div>Loading...</div>;
    }
    return (
      <React.Fragment>
        <div className="flex-1 min-w-0 h-max">
          <Paper className={classes.root}>
            <div className="flex justify-between gap-4">
              <div
                id="inputs"
                className="w-full gap-8 flex flex-col"
                style={{
                  display: "flex flex-col items-center justify-center text-center",
                }}
              >
                <PlayerInfo
                  Player={player}
                  InsertPlayer={InsertPlayer}
                  Updateplayer={Updateplayer}
                  ChangeUser={changeUser}
                  requestPlayerInfo={requestPlayerInfo}
                  updatePlayerField={updatePlayerField}
                />
                <hr className="my-3" />
              </div>
              {player && props.match.params.id !== "0" && !fullscreen && (
                <div className="flex-grow-0 h-max ">
                  <PlayerStatistics
                    Player={player}
                    needsToReload={statsNeedsReload}
                  />
                </div>
              )}
            </div>
            {props.match.params.id !== "0" ? (
              <PlayerTabs
                AgentInfo={props.location}
                Player={player}
                InsertPlayer={InsertPlayer}
                Updateplayer={Updateplayer}
                showLoading={props.showLoading}
                setStatisticsToReload={setStatisticsToReload}
                requestPlayerInfo={requestPlayerInfo}
                updatePlayerField={updatePlayerField}
              />
            ) : (
              <PlayerWagering
                Player={player}
                UpdatePlayer={Updateplayer}
                InsertPlayer={InsertPlayer}
                updatePlayerField={updatePlayerField}
              />
            )}
          </Paper>
        </div>
      </React.Fragment>
    );
  })
);

export default Player;